// src/features/legacy-quantilia/issuer_events/table.tsx

import { Table } from "../../features/Table";
import { type IssuerEvent, issuer_event_columns } from "./columns";
import { FilterIssuerEvent } from "./filter";

const client = "legacy-quantilia";
const table_name = "issuer_events";

export const IssuerEventsTable = () => {
  return (
    <Table<IssuerEvent, IssuerEvent>
      label="Issuer Events"
      client={client}
      table_name={table_name}
      columns={issuer_event_columns}
      filter={<FilterIssuerEvent />}
      disable_translations_request={true}
    />
  );
};
